module.exports = __webpack_public_path__ + "img/tree.6857ac2d.svg";